module.exports = __webpack_public_path__ + "img/header.048b9aad.jpg";